import TALENTBYTECHNOLOGYFRONTEND from 'data/mantechcar24/talent-by-technology-frontend.json';
import { useI18n } from 'hooks/useI18n';
import React from 'react';
import {
  Bar,
  BarChart,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';
import { StyledCell, StyledHeader, StyledTable } from './TalentByTech.styled';

const TalentByTechFrontend: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');

  return (
    <div>
      <StyledTable>
        <StyledHeader>
          {t('mantechcar24.talent.talent-per-tech.order')}
        </StyledHeader>
        <StyledHeader>
          {t('mantechcar24.talent.talent-per-tech.technology')}
        </StyledHeader>
        <StyledHeader>
          {t('mantechcar24.talent.talent-per-tech.talent-share')}
        </StyledHeader>
        <StyledHeader>
          {t('mantechcar24.talent.talent-per-tech.years-experience')}
        </StyledHeader>
        {TALENTBYTECHNOLOGYFRONTEND.map((item, index) => (
          <React.Fragment key={index}>
            <StyledCell>{item.position}</StyledCell>
            <StyledCell>{item.tech}</StyledCell>
            <StyledCell className="hasChart">
              <StyledRecharts>
                <ResponsiveContainer height={50} width="99%">
                  <BarChart
                    data={[item]}
                    layout="vertical"
                    margin={{ left: 18 }}
                  >
                    <XAxis type="number" domain={[0, 25]} hide={true}></XAxis>
                    <YAxis type="category" dataKey="tech" hide={true} />
                    <Bar
                      dataKey="shareValue"
                      fill="#9dcac2"
                      barSize={8}
                      radius={12}
                      isAnimationActive={false}
                    >
                      <LabelList
                        dataKey="shareValue"
                        formatter={(shareValue: number) => {
                          return `${shareValue}%`;
                        }}
                        position="right"
                      />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </StyledRecharts>
            </StyledCell>
            <StyledCell className="hasChart">
              <StyledRecharts>
                <ResponsiveContainer height={50} width="100%">
                  <BarChart data={[item]} layout="vertical">
                    <XAxis type="number" domain={[0, 100]} hide={true}></XAxis>
                    <YAxis type="category" dataKey="tech" hide={true} />
                    <Bar
                      dataKey="experienceTier1"
                      stackId="a"
                      barSize={10}
                      radius={5}
                      fill="#DEEBF7"
                      isAnimationActive={false}
                      style={{ stroke: '#fff', strokeWidth: 2 }}
                    >
                      <LabelList
                        dataKey="shareValue"
                        formatter={() => {
                          return '0-2';
                        }}
                        position="bottom"
                      />
                    </Bar>
                    <Bar
                      dataKey="experienceTier2"
                      stackId="a"
                      barSize={10}
                      radius={5}
                      fill="#6BAED6"
                      isAnimationActive={false}
                      style={{ stroke: '#fff', strokeWidth: 2 }}
                    >
                      <LabelList
                        dataKey="shareValue"
                        formatter={() => {
                          return '2-5';
                        }}
                        position="bottom"
                      />
                    </Bar>
                    <Bar
                      dataKey="experienceTier3"
                      stackId="a"
                      barSize={10}
                      radius={5}
                      fill="#2171B5"
                      isAnimationActive={false}
                      style={{ stroke: '#fff', strokeWidth: 2 }}
                    >
                      <LabelList
                        dataKey="shareValue"
                        formatter={() => {
                          return '5-10';
                        }}
                        position="bottom"
                      />
                    </Bar>
                    <Bar
                      dataKey="experienceTier4"
                      stackId="a"
                      barSize={10}
                      radius={5}
                      fill="#08306B"
                      isAnimationActive={false}
                      style={{ stroke: '#fff', strokeWidth: 2 }}
                    >
                      <LabelList
                        dataKey="shareValue"
                        formatter={() => {
                          return '+10';
                        }}
                        position="bottom"
                      />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </StyledRecharts>
            </StyledCell>
          </React.Fragment>
        ))}
      </StyledTable>
    </div>
  );
};

export default TalentByTechFrontend;
